<template>
	<div>
		<a-form-model ref="editForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"  :model="theEditObj" :rules="rules">
			<a-form-model-item label="公司名称"  prop="companyName">
				<a-input v-model="theEditObj.companyName"/>
			</a-form-model-item>
			<a-form-model-item label="公司地址"  prop="companyAddr">
				<a-input v-model="theEditObj.companyAddr"/>
			</a-form-model-item>
			<a-form-model-item label="公司标识"  prop="mark">
				<a-input v-model="theEditObj.mark" />
			</a-form-model-item>
			<a-form-model-item label="邮箱主机" prop="emailHost">
				<a-input v-model="theEditObj.emailHost" />
			</a-form-model-item>
			<a-form-model-item label="邮箱用户名"  prop="emailUser">
				<a-input v-model="theEditObj.emailUser"/>
			</a-form-model-item>
			<a-form-model-item label="缴费地址"  prop="payAddr">
				<a-input v-model="theEditObj.payAddr"/>
			</a-form-model-item>
			<a-form-model-item label="查询电话"  prop="telephone">
				<a-input v-model="theEditObj.telephone"/>
			</a-form-model-item>
			<a-form-model-item label="备注">
				<a-textarea v-model="theEditObj.remark"  :auto-size="{ minRows: 3, maxRows: 6 }"/>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:['theEditObj'],
		data(){
			return{
				submitFlag:false,
				rules:{
					companyName:[{required:true,message:'请输入公司名称',trigger: 'blur'}],
					companyAddr:[{required:true,message:'请输入公司地址',trigger: 'blur'}],
					mark:[{required:true,message:'请输入公司标识',trigger: 'blur'}],
					emailHost:[{required:true,message:'请输入邮箱主机',trigger: 'blur'}],
					emailUser:[{required:true,message:'请输入邮箱用户名',trigger: 'blur'}],
					payAddr:[{required:true,message:'请输入缴费地址',trigger: 'blur'}],
					telephone:[{required:true,message:'请输入查询电话',trigger: 'blur'}],
				}
			}
		},
		methods:{
			onClose:function(flag){
				this.$emit('cancelEdit');
				if(flag){
					this.$message.success('修改成功');
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				this.$refs.editForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.EDIT_WATER_COMPANY_URL);
				this.Api.fetchPostWithForm(url,this.theEditObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.submitFlag = false;
					console.log(error);
				});
			}
		},
	}
</script>

<style>
	.drawerFooter{
		position: absolute;
		right:0;
		bottom:0;
		width: 100%;
		background:white;
		padding: 0.625rem 1rem;
		z-index: 1;
		border-top:  0.0625rem  solid  #e9e9e9;
		text-align: right;
	}
</style>
